module.exports = __webpack_public_path__ + "static/flower.56b218db.png";